import { createSelector } from 'reselect';
import { getScopes } from './getScopes';
export const getScopesAsSet = createSelector(getScopes, scopes => new Set(scopes));